import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit, half } = measures

export const select = {
  control: (state) => {
    if (state.isDisabled) {
      return { backgroundColor: 'transparent' }
    }
  },

  indicatorsContainer: (state) => {
    if (state.isDisabled) {
      return { display: 'none' }
    }
  },
}

export const control = css`
  &:disabled {
    background-color: transparent;
  }
`

export const row = css`
  display: flex;
  align-items: center;
  min-height: ${8 * unit}px;
  gap: ${2 * unit}px;
  ${MQ.PHONES} {
    justify-content: space-between;
  }

  & label {
    min-width: ${14 * unit}px;
    margin-bottom: ${2 * unit}px;
  }
`

export const rowWithToggle = css`
  display: flex;
  align-items: center;
  min-height: ${8 * unit}px;
  gap: ${2 * unit}px;

  & label {
    min-width: ${14 * unit}px;
    margin-bottom: ${9 * half}px;
    ${MQ.PHONES} {
      margin-right: ${4 * unit}px;
    }
  }
`
